import { ZoomFilterViewModel } from './zoom-filter-view-model';
import { ZoomMetaData } from '../../../meta-data/zoom-meta-data';
import { ZoomOperatorViewModelProperty } from '../zoom-operator-view-model-property';
import { ZoomPropertyViewModelInterface } from '../property-view-model/zoom-property-view-model.interface';
import { ExternalZoomPropertyViewModel } from '../property-view-model/external-zoom-property-view-model';
import { BigNumber, FilterOperators } from '@nts/std/types';
import type { ModifiedSubscriberInterface } from '@nts/std/interfaces';

export class ExternalZoomFilterViewModel extends ZoomFilterViewModel<{ identity: { [key: string]: string | number | BigNumber; }, description?: string, isValid?: boolean; }> {

  parentExternalFilter: ZoomFilterViewModel<any> | ExternalZoomFilterViewModel = null;

  constructor(metadata: ZoomMetaData, private modifiedSubscriber: ModifiedSubscriberInterface) {
    super(metadata);
    this.operator = new ZoomOperatorViewModelProperty(
      ZoomOperatorViewModelProperty.operatorsForExternal,
      modifiedSubscriber
    );
    this.filterValue = new ExternalZoomPropertyViewModel(metadata.external, modifiedSubscriber);
    this.filterValue2 = new ExternalZoomPropertyViewModel(metadata.external, modifiedSubscriber);
    this.internalZoomPropertyViewModelValues = [new ExternalZoomPropertyViewModel(metadata.external, modifiedSubscriber)];
    this.init();
  }

  setZoomPropertyViewModelValuesFromEntities(entities: Array<{ identity: { [key: string]: string | number; }, description?: string, isValid?: boolean; }>) {
    this.setZoomPropertyViewModelValues(entities.map((e: { identity: { [key: string]: string | number; }, description?: string, isValid?: boolean; }) => {
      const vm = this.getEmptyFilter();
      vm.setValue(e);
      return vm;
    }));
  }

  override addNewFilterInValues() {
    const vm = this.getEmptyFilter();
    vm.setEnabled(true);
    if (this.filterValues?.length > 0) {
      this.setZoomPropertyViewModelValues([...this.filterValues, vm]);
    } else {
      this.setZoomPropertyViewModelValues([vm]);
    }
  }

  override deleteFilterInValues(inToRemove: ZoomPropertyViewModelInterface<{ identity: { [key: string]: string | number; }, description?: string, isValid?: boolean; }>) {
    const indexToRemove = this.filterValues.indexOf(inToRemove);

    if (this.filterValues?.length > 0 && indexToRemove > -1) {
      this.filterValues.splice(indexToRemove, 1);
      this.modifiedSubscriber.notifyModified();
    }
  }

  protected override async onOperatorChanged(value: FilterOperators): Promise<void> {
    await super.onOperatorChanged(value);
    if (this.OperatorDoesNotRequireValue) {
      for (const filter of this.filterValues) {
        filter.setEnabled(false);
        await filter.resetValue();
      }
    } else {
      for (const filter of this.filterValues) {
        filter.setEnabled(true);
      }
    }
  }

  override async checkOperatorSupport(): Promise<boolean> {
    if (
      this.operator.currentValue === FilterOperators.In ||
      this.operator.currentValue === FilterOperators.Between
    ) {
      const associationPropertiesWithoutCompanyId = this.metaData.external.associationProperties.filter(
        p => p.principalPropertyName.toLowerCase() !== 'companyid'
      );

      return Promise.resolve(associationPropertiesWithoutCompanyId.length === 1);
    }
    return Promise.resolve(true);
  }

  getEmptyFilter(): ExternalZoomPropertyViewModel {
    return new ExternalZoomPropertyViewModel(this.metaData.external, this.modifiedSubscriber);
  }

  get filterValues(): Array<ZoomPropertyViewModelInterface<{ identity: { [key: string]: string | number | BigNumber; }, description?: string, isValid?: boolean; }>> {
    return this.internalZoomPropertyViewModelValues;
  }

  private internalZoomPropertyViewModelValues: Array<ZoomPropertyViewModelInterface<{ identity: { [key: string]: string | number | BigNumber; }, description?: string, isValid?: boolean; }>> = [];

  setZoomPropertyViewModelValues(pvmToSet: Array<ZoomPropertyViewModelInterface<{ identity: { [key: string]: string | number | BigNumber; }, description?: string, isValid?: boolean; }>>) {
    if (this.internalZoomPropertyViewModelValues != pvmToSet) {
      this.internalZoomPropertyViewModelValues = pvmToSet;
      this.modifiedSubscriber.notifyModified();
    }
  }
}
